import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

function Confidentialite() {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const lang = i18n.language || 'fr';

  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4">
      <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-lg p-8">
        <button
          onClick={() => navigate('/')}
          className="text-primary-600 hover:text-primary-700 font-semibold mb-6"
        >
          ← {lang === 'fr' ? 'Retour' : 'Back'}
        </button>

        <h1 className="text-4xl font-bold text-gray-900 mb-8">
          {lang === 'fr' ? 'Politique de Confidentialité' : 'Privacy Policy'}
        </h1>

        {lang === 'fr' ? (
          <>
            <div className="bg-blue-50 border-l-4 border-blue-500 p-4 mb-8">
              <p className="text-sm text-blue-800">
                <strong>Dernière mise à jour :</strong> 31 janvier 2026
              </p>
            </div>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">1. Introduction</h2>
              <p className="text-gray-700 mb-4">
                BEL-AN Prod, éditeur de ProjectBoost, accorde une grande importance à la protection de vos données 
                personnelles. Cette politique de confidentialité vous informe sur la manière dont nous collectons, 
                utilisons et protégeons vos données conformément au Règlement Général sur la Protection des Données (RGPD).
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">2. Responsable du traitement</h2>
              <p className="text-gray-700 mb-2">
                <strong>BEL-AN Prod</strong>
              </p>
              <p className="text-gray-700 mb-2">
                <strong>Entrepreneur Individuel :</strong> MOMO KOUNTCHOU Arthur
              </p>
              <p className="text-gray-700 mb-2">
                <strong>Adresse :</strong> 28 Rue de Courdimanche, 91940 Les Ulis, France
              </p>
              <p className="text-gray-700 mb-2">
                <strong>Email :</strong> ace.direction22@gmail.com
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">3. Données collectées</h2>
              
              <h3 className="text-xl font-semibold text-gray-800 mb-3 mt-6">3.1. Données d'identification</h3>
              <ul className="list-disc list-inside text-gray-700 mb-4 space-y-2">
                <li>Adresse email (obligatoire pour la création de compte)</li>
                <li>Mot de passe (chiffré)</li>
                <li>Type d'abonnement (Free, Silver, Gold)</li>
              </ul>

              <h3 className="text-xl font-semibold text-gray-800 mb-3 mt-6">3.2. Données de diagnostic</h3>
              <ul className="list-disc list-inside text-gray-700 mb-4 space-y-2">
                <li>Nom de l'organisation</li>
                <li>Nom du projet</li>
                <li>Nom du chef de projet</li>
                <li>Nombre de participants</li>
                <li>Réponses au questionnaire (24 questions)</li>
                <li>Date de réalisation du diagnostic</li>
              </ul>

              <h3 className="text-xl font-semibold text-gray-800 mb-3 mt-6">3.3. Données de paiement</h3>
              <ul className="list-disc list-inside text-gray-700 mb-4 space-y-2">
                <li>Informations de paiement (traitées exclusivement par Stripe, non stockées par ProjectBoost)</li>
                <li>Historique des transactions</li>
                <li>Statut d'abonnement</li>
              </ul>

              <h3 className="text-xl font-semibold text-gray-800 mb-3 mt-6">3.4. Données de navigation</h3>
              <ul className="list-disc list-inside text-gray-700 mb-4 space-y-2">
                <li>Cookies techniques nécessaires au fonctionnement du site</li>
                <li>Données de connexion (date, heure)</li>
                <li>Préférences linguistiques</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">4. Finalités du traitement</h2>
              <p className="text-gray-700 mb-4">Vos données sont collectées et traitées pour :</p>
              <ul className="list-disc list-inside text-gray-700 mb-4 space-y-2">
                <li>Créer et gérer votre compte utilisateur</li>
                <li>Fournir les services de diagnostic de projet</li>
                <li>Générer et stocker vos rapports de diagnostic</li>
                <li>Gérer vos abonnements et paiements</li>
                <li>Vous donner accès à la bibliothèque de ressources (abonnement Gold)</li>
                <li>Améliorer nos services</li>
                <li>Respecter nos obligations légales</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">5. Base légale du traitement</h2>
              <ul className="list-disc list-inside text-gray-700 mb-4 space-y-2">
                <li><strong>Exécution du contrat :</strong> gestion de votre compte et fourniture des services</li>
                <li><strong>Intérêt légitime :</strong> amélioration de nos services</li>
                <li><strong>Obligation légale :</strong> conformité fiscale et comptable</li>
                <li><strong>Consentement :</strong> cookies non essentiels (si applicable)</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">6. Durée de conservation</h2>
              <ul className="list-disc list-inside text-gray-700 mb-4 space-y-2">
                <li><strong>Compte actif :</strong> durée de votre abonnement + 3 ans</li>
                <li><strong>Données de diagnostic :</strong> durée de votre abonnement + 1 an</li>
                <li><strong>Données de paiement :</strong> 10 ans (obligation légale)</li>
                <li><strong>Données de connexion :</strong> 1 an maximum</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">7. Destinataires des données</h2>
              <p className="text-gray-700 mb-4">Vos données peuvent être transmises à :</p>
              <ul className="list-disc list-inside text-gray-700 mb-4 space-y-2">
                <li><strong>Firebase (Google Cloud) :</strong> hébergement et base de données</li>
                <li><strong>Stripe :</strong> traitement des paiements</li>
                <li><strong>Personnel autorisé de BEL-AN Prod :</strong> support technique</li>
              </ul>
              <p className="text-gray-700 mb-4">
                Nous ne vendons ni ne louons vos données personnelles à des tiers.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">8. Transferts internationaux</h2>
              <p className="text-gray-700 mb-4">
                Vos données peuvent être hébergées sur des serveurs situés dans l'Union Européenne ou aux États-Unis 
                (Firebase/Google Cloud). Ces transferts sont encadrés par des clauses contractuelles types approuvées 
                par la Commission Européenne.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">9. Vos droits</h2>
              <p className="text-gray-700 mb-4">Conformément au RGPD, vous disposez des droits suivants :</p>
              <ul className="list-disc list-inside text-gray-700 mb-4 space-y-2">
                <li><strong>Droit d'accès :</strong> obtenir une copie de vos données</li>
                <li><strong>Droit de rectification :</strong> corriger vos données inexactes</li>
                <li><strong>Droit à l'effacement :</strong> supprimer vos données (sous conditions)</li>
                <li><strong>Droit à la limitation :</strong> limiter le traitement de vos données</li>
                <li><strong>Droit à la portabilité :</strong> récupérer vos données dans un format structuré</li>
                <li><strong>Droit d'opposition :</strong> vous opposer au traitement de vos données</li>
                <li><strong>Droit de retirer votre consentement :</strong> à tout moment</li>
              </ul>
              <p className="text-gray-700 mb-4">
                Pour exercer vos droits, contactez-nous à : <a href="mailto:ace.direction22@gmail.com" className="text-primary-600 hover:underline">ace.direction22@gmail.com</a>
              </p>
              <p className="text-gray-700 mb-4">
                Vous disposez également du droit d'introduire une réclamation auprès de la CNIL (Commission Nationale de l'Informatique et des Libertés).
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">10. Sécurité des données</h2>
              <p className="text-gray-700 mb-4">
                Nous mettons en œuvre des mesures techniques et organisationnelles appropriées pour protéger vos données :
              </p>
              <ul className="list-disc list-inside text-gray-700 mb-4 space-y-2">
                <li>Chiffrement des mots de passe</li>
                <li>Connexions HTTPS sécurisées</li>
                <li>Accès restreint aux données</li>
                <li>Sauvegardes régulières</li>
                <li>Surveillance de sécurité</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">11. Cookies</h2>
              <p className="text-gray-700 mb-4">
                Pour plus d'informations sur l'utilisation des cookies, consultez notre <a href="/cookies" className="text-primary-600 hover:underline">Politique de Cookies</a>.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">12. Modifications</h2>
              <p className="text-gray-700 mb-4">
                Nous nous réservons le droit de modifier cette politique de confidentialité à tout moment. 
                La date de dernière mise à jour est indiquée en haut de cette page. Nous vous encourageons 
                à consulter régulièrement cette page.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">13. Contact</h2>
              <p className="text-gray-700 mb-4">
                Pour toute question concernant cette politique de confidentialité ou le traitement de vos données :
              </p>
              <p className="text-gray-700 mb-2">
                Email : <a href="mailto:ace.direction22@gmail.com" className="text-primary-600 hover:underline">ace.direction22@gmail.com</a>
              </p>
            </section>
          </>
        ) : (
          <>
            <div className="bg-blue-50 border-l-4 border-blue-500 p-4 mb-8">
              <p className="text-sm text-blue-800">
                <strong>Last updated:</strong> January 31, 2026
              </p>
            </div>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">1. Introduction</h2>
              <p className="text-gray-700 mb-4">
                BEL-AN Prod, publisher of ProjectBoost, attaches great importance to the protection of your personal data. 
                This privacy policy informs you about how we collect, use and protect your data in accordance with 
                the General Data Protection Regulation (GDPR).
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">2. Data Controller</h2>
              <p className="text-gray-700 mb-2">
                <strong>BEL-AN Prod</strong>
              </p>
              <p className="text-gray-700 mb-2">
                <strong>Individual Entrepreneur:</strong> MOMO KOUNTCHOU Arthur
              </p>
              <p className="text-gray-700 mb-2">
                <strong>Address:</strong> 28 Rue de Courdimanche, 91940 Les Ulis, France
              </p>
              <p className="text-gray-700 mb-2">
                <strong>Email:</strong> ace.direction22@gmail.com
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">3. Data Collected</h2>
              
              <h3 className="text-xl font-semibold text-gray-800 mb-3 mt-6">3.1. Identification Data</h3>
              <ul className="list-disc list-inside text-gray-700 mb-4 space-y-2">
                <li>Email address (required for account creation)</li>
                <li>Password (encrypted)</li>
                <li>Subscription type (Free, Silver, Gold)</li>
              </ul>

              <h3 className="text-xl font-semibold text-gray-800 mb-3 mt-6">3.2. Diagnostic Data</h3>
              <ul className="list-disc list-inside text-gray-700 mb-4 space-y-2">
                <li>Organization name</li>
                <li>Project name</li>
                <li>Project manager name</li>
                <li>Number of participants</li>
                <li>Questionnaire responses (24 questions)</li>
                <li>Diagnostic completion date</li>
              </ul>

              <h3 className="text-xl font-semibold text-gray-800 mb-3 mt-6">3.3. Payment Data</h3>
              <ul className="list-disc list-inside text-gray-700 mb-4 space-y-2">
                <li>Payment information (processed exclusively by Stripe, not stored by ProjectBoost)</li>
                <li>Transaction history</li>
                <li>Subscription status</li>
              </ul>

              <h3 className="text-xl font-semibold text-gray-800 mb-3 mt-6">3.4. Browsing Data</h3>
              <ul className="list-disc list-inside text-gray-700 mb-4 space-y-2">
                <li>Technical cookies necessary for website operation</li>
                <li>Connection data (date, time)</li>
                <li>Language preferences</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">4. Processing Purposes</h2>
              <p className="text-gray-700 mb-4">Your data is collected and processed to:</p>
              <ul className="list-disc list-inside text-gray-700 mb-4 space-y-2">
                <li>Create and manage your user account</li>
                <li>Provide project diagnostic services</li>
                <li>Generate and store your diagnostic reports</li>
                <li>Manage your subscriptions and payments</li>
                <li>Give you access to the resource library (Gold subscription)</li>
                <li>Improve our services</li>
                <li>Comply with our legal obligations</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">5. Legal Basis for Processing</h2>
              <ul className="list-disc list-inside text-gray-700 mb-4 space-y-2">
                <li><strong>Contract performance:</strong> account management and service provision</li>
                <li><strong>Legitimate interest:</strong> service improvement</li>
                <li><strong>Legal obligation:</strong> tax and accounting compliance</li>
                <li><strong>Consent:</strong> non-essential cookies (if applicable)</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">6. Retention Period</h2>
              <ul className="list-disc list-inside text-gray-700 mb-4 space-y-2">
                <li><strong>Active account:</strong> duration of your subscription + 3 years</li>
                <li><strong>Diagnostic data:</strong> duration of your subscription + 1 year</li>
                <li><strong>Payment data:</strong> 10 years (legal obligation)</li>
                <li><strong>Connection data:</strong> 1 year maximum</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">7. Data Recipients</h2>
              <p className="text-gray-700 mb-4">Your data may be transmitted to:</p>
              <ul className="list-disc list-inside text-gray-700 mb-4 space-y-2">
                <li><strong>Firebase (Google Cloud):</strong> hosting and database</li>
                <li><strong>Stripe:</strong> payment processing</li>
                <li><strong>Authorized BEL-AN Prod personnel:</strong> technical support</li>
              </ul>
              <p className="text-gray-700 mb-4">
                We do not sell or rent your personal data to third parties.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">8. International Transfers</h2>
              <p className="text-gray-700 mb-4">
                Your data may be hosted on servers located in the European Union or the United States 
                (Firebase/Google Cloud). These transfers are governed by standard contractual clauses 
                approved by the European Commission.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">9. Your Rights</h2>
              <p className="text-gray-700 mb-4">Under GDPR, you have the following rights:</p>
              <ul className="list-disc list-inside text-gray-700 mb-4 space-y-2">
                <li><strong>Right of access:</strong> obtain a copy of your data</li>
                <li><strong>Right of rectification:</strong> correct inaccurate data</li>
                <li><strong>Right to erasure:</strong> delete your data (under conditions)</li>
                <li><strong>Right to restriction:</strong> limit processing of your data</li>
                <li><strong>Right to portability:</strong> retrieve your data in a structured format</li>
                <li><strong>Right to object:</strong> object to processing of your data</li>
                <li><strong>Right to withdraw consent:</strong> at any time</li>
              </ul>
              <p className="text-gray-700 mb-4">
                To exercise your rights, contact us at: <a href="mailto:ace.direction22@gmail.com" className="text-primary-600 hover:underline">ace.direction22@gmail.com</a>
              </p>
              <p className="text-gray-700 mb-4">
                You also have the right to lodge a complaint with your national data protection authority.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">10. Data Security</h2>
              <p className="text-gray-700 mb-4">
                We implement appropriate technical and organizational measures to protect your data:
              </p>
              <ul className="list-disc list-inside text-gray-700 mb-4 space-y-2">
                <li>Password encryption</li>
                <li>Secure HTTPS connections</li>
                <li>Restricted data access</li>
                <li>Regular backups</li>
                <li>Security monitoring</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">11. Cookies</h2>
              <p className="text-gray-700 mb-4">
                For more information about cookie usage, see our <a href="/cookies" className="text-primary-600 hover:underline">Cookie Policy</a>.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">12. Changes</h2>
              <p className="text-gray-700 mb-4">
                We reserve the right to modify this privacy policy at any time. The last update date is 
                indicated at the top of this page. We encourage you to consult this page regularly.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">13. Contact</h2>
              <p className="text-gray-700 mb-4">
                For any questions regarding this privacy policy or the processing of your data:
              </p>
              <p className="text-gray-700 mb-2">
                Email: <a href="mailto:ace.direction22@gmail.com" className="text-primary-600 hover:underline">ace.direction22@gmail.com</a>
              </p>
            </section>
          </>
        )}

        <div className="mt-12 pt-8 border-t border-gray-200 text-center text-sm text-gray-500">
          <p>© 2026 BEL-AN Prod - ProjectBoost. {lang === 'fr' ? 'Tous droits réservés.' : 'All rights reserved.'}</p>
        </div>
      </div>
    </div>
  );
}

export default Confidentialite;
